<template>
<!-- 英文PC -->
  <div
    class="index"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <div class="indexTop hidden-xs-only">
      <div class="indexTopSwiper">
        <el-carousel height="630px">
          <el-carousel-item v-for="(item, i) in swiperList" :key="i">
            <img :src="item.imgSrc" />
            <div class="ItemTitle eng_ItemTitle">{{ item.eng_title }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hotArtIntroduce">
        <div class="section">
          <div class="hotArt">
            <div class="hotArt_text za_hotArt_text eng_hotArt_text">
              Regong Art
            </div>
          </div>
          <div class="wow artContent animate__animated animate__bounceInRight">
            <img
              class="indexOne animate__animated animate__backInLeft eng_indexOne"
              src="../assets/newImage/index/index_1.jpg"
              alt
            />
            <div class="contentTop za_contentTop">
              <div class="title">
                <p>
                  Tongren, "Regong" in Tibetan means "golden valley where dreams
                  come true".
                </p>
                <p>
                  The well-known art of Regong is named after its origin here.
                </p>
                <p>
                  Regong art was born in the 13th century and includes Thangka,
                  murals, pile embroidery, sculpture and other art forms. It is
                  an important local traditional art school.
                </p>
                <p>
                  In 2006, Regon art was included in the first national
                  intangible cultural heritage list.
                </p>
                <p>
                  In 2009, Regong Art was selected into the list of
                  representative works of the intangible cultural heritage of
                  mankind.
                </p>
                <p>
                  In 2018, Regon Art was selected into the first batch of
                  national traditional craft revitalization catalogues.
                </p>
                <br />
                <p>
                  General Secretary Xi once pointed out
                  <strong
                    >that it is necessary to promote the systematic protection
                    of the cultural heritage of the Yellow River and protect the
                    precious heritage left to us by our ancestors.</strong
                  >
                </p>
              </div>
            </div>
          </div>
          <div
            class="indexTopleft wow artContent animate__animated animate__fadeInLeft"
          >
            <img src="../assets/indexImage/index_5.png" alt />
          </div>
        </div>
      </div>
      <div class="inheritor">
        <div id="all-box">
          <div
            v-for="(item, index) in List"
            :class="[
              'c-item-' + index,
              currsorIndex == index ? 'c-item-hover' : '',
            ]"
            @mouseover="mouseOver(index)"
            :key="index"
          >
            <div v-show="currsorIndex != index" class="title-box engLish_title-box">
              {{ item.englishName }}
            </div>
            <div class="currsor-content-box" v-if="index != 9 && index != 0">
              <div class="img">
                <img :src="url + item.picture[0].fileUrl" />
              </div>
              <div class="currsor-title-box">{{ item.englishName }}</div>
              <div class="inheritorNameList" v-if="item.inheritorLevelIdArrStr&&item.inheritorLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.inheritorLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">Representative inheritor of Regong art, a national intangible cultural heritage project</div>
                  <div v-if="items&&items==2">Representative inheritor of Regong art, an intangible cultural heritage project in Qinghai Province</div>
                  <div v-if="items&&items==3">Representative inheritor of Regong art, an intangible cultural heritage project in Huangnan Prefecture, Qinghai Province</div>
                  <div v-if="items&&items==4">Representative inheritor of Regong art, an intangible cultural heritage project in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                </div>
              </div>
              <div class="artistsLevelNameList" v-if="item.artistsLevelIdArrStr&&item.artistsLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.artistsLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">Chinese Arts and Crafts Masters</div>
                  <div v-if="items&&items==2">Master of Arts and Crafts in Qinghai Province</div>
                  <div v-if="items&&items==3">Master of Arts and Crafts in Huangnan Prefecture, Qinghai Province</div>
                  <div v-if="items&&items==4">Master of Arts and Crafts in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item&&item.technologistLevel==1">Qinghai Province Folk Crafts Master</div>
                <div v-if="item&&item.technologistLevel==2">Qinghai Provincial First Class Folk Craftsman</div>
                <div v-if="item&&item.technologistLevel==3">Qinghai Provincial Second Class Folk Craftsman</div>
                <div v-if="item&&item.technologistLevel==4">Qinghai Provincial Third Class Folk Craftsman</div>
                <div v-if="item&&item.technologistLevel==5">Folk Craftsman of Huangnan Prefecture, Qinghai Province</div>
                <div v-if="item&&item.technologistLevel==6">Folk Craftsman in Tongren City, Huangnan Prefecture, Qinghai Province</div>
              </div>
            </div>
            <div class="currsor-content-box" v-if="index == 0">
              <div class="currsor-title-box">{{ item.englishName }}</div>
            </div>
            <div
              class="currsor-content-box"
              @click="goDetail"
              v-if="index == 9"
            >
              <div class="currsor-title-box">{{ item.englishName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="indexMiddle hidden-xs-only">
      <div class="section">
        <div class="tarbar">
          <tab-bar :tabNames="tabNamesList" @getIndex="getTarbar"></tab-bar>
        </div>
        <message-list :message="item"></message-list>
      </div>
    </div>
    <!-- 英文手机端 -->
    <div class="mobile_indexTop hidden-sm-and-up">
      <div class="mobile_top">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(item, i) in mobileSwiperList" :key="i">
            <img :src="item.imgSrc" />
            <div class="ItemTitle eng_ItemTitle">{{ item.eng_title }}</div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="mobile_Introduce wow animate__animated animate__fadeInDown">
        <div class="section">
          <div class="hotArt">
            <div class="hotArt_title">
              <div class="hotArt_text za_hotArt_text">Regong Art</div>
            </div>
          </div>
          <div class="pic">
            <img src="../assets/newImage/index/index_1.jpg" alt="" />
          </div>
          <div class="contentTop">
            <p>
              Tongren, "Regong" in Tibetan means "golden valley where dreams
              come true".
            </p>
            <p>The well-known art of Regong is named after its origin here.</p>
            <p>
              Regong art was born in the 13th century and includes Thangka,
              murals, pile embroidery, sculpture and other art forms. It is an
              important local traditional art school.
            </p>
            <p>
              In 2006, Regon art was included in the first national intangible
              cultural heritage list.
            </p>
            <p>
              In 2009, Regong Art was selected into the list of representative
              works of the intangible cultural heritage of mankind.
            </p>
            <p>
              In 2018, Regon Art was selected into the first batch of national
              traditional craft revitalization catalogues.
            </p>
            <br />
            <p>
              General Secretary Xi once pointed out
              <strong
                >that it is necessary to promote the systematic protection of
                the cultural heritage of the Yellow River and protect the
                precious heritage left to us by our ancestors.</strong
              >
            </p>
          </div>
          <div class="indexList">
            <img src="../assets/newImage/mobile/index/index_1.png" alt />
          </div>
        </div>
        <img
          class="cloudLeft wow animate__animated animate__fadeInLeft"
          src="../assets/newImage/index/could_left.png"
          alt
        />
      </div>
      <div class="mobile_inheritor">
        <div class="hotArt">Inheritor</div>
        <div id="all-box">
          <div
            v-for="(item, index) in list"
            :class="[
              'c-item-' + index,
              currsorIndex == index ? 'c-item-hover' : '',
            ]"
            @mouseover="mobileMouseOver(index)"
            :key="index"
          >
            <div v-show="currsorIndex != index" class="title-box engLish_title-box">
              {{ item.englishName }}
            </div>
            <div class="currsor-content-box" v-if="index !== 3">
              <div class="img">
                <img :src="url + item.picture[0].fileUrl" />
              </div>
              <div class="currsor-title-box">{{ item.englishName }}</div>
              <div class="inheritorNameList" v-if="item.inheritorLevelIdArrStr&&item.inheritorLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.inheritorLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">Representative inheritor of Regong art, a national intangible cultural heritage project</div>
                  <div v-if="items&&items==2">Representative inheritor of Regong art, an intangible cultural heritage project in Qinghai Province</div>
                  <div v-if="items&&items==3">Representative inheritor of Regong art, an intangible cultural heritage project in Huangnan Prefecture, Qinghai Province</div>
                  <div v-if="items&&items==4">Representative inheritor of Regong art, an intangible cultural heritage project in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                </div>
              </div>
              <div class="artistsLevelNameList" v-if="item.artistsLevelIdArrStr&&item.artistsLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.artistsLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">Chinese Arts and Crafts Masters</div>
                  <div v-if="items&&items==2">Master of Arts and Crafts in Qinghai Province</div>
                  <div v-if="items&&items==3">Master of Arts and Crafts in Huangnan Prefecture, Qinghai Province</div>
                  <div v-if="items&&items==4">Master of Arts and Crafts in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item&&item.technologistLevel==1">Qinghai Province Folk Crafts Master</div>
                <div v-if="item&&item.technologistLevel==2">Qinghai Provincial First Class Folk Craftsman</div>
                <div v-if="item&&item.technologistLevel==3">Qinghai Provincial Second Class Folk Craftsman</div>
                <div v-if="item&&item.technologistLevel==4">Qinghai Provincial Third Class Folk Craftsman</div>
                <div v-if="item&&item.technologistLevel==5">Folk Craftsman of Huangnan Prefecture, Qinghai Province</div>
                <div v-if="item&&item.technologistLevel==6">Folk Craftsman in Tongren City, Huangnan Prefecture, Qinghai Province</div>
              </div>
            </div>
            <div class="currsor-content-box" @click="goDetail" v-else>
              <div class="currsor-title-box">{{ item.englishName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_tarbar">
        <div class="section">
          <tab-bar :tabNames="tabNamesList" @getIndex="getTarbar"></tab-bar>
        </div>
      </div>
      <div class="section">
        <message-list :message="item"></message-list>
      </div>
    </div>
  </div>
  <!-- 藏文PC -->
  <div class="index" v-else-if="this.language == 'en'">
    <div class="indexTop hidden-xs-only">
      <div class="indexTopSwiper">
        <el-carousel height="630px">
          <el-carousel-item v-for="(item, i) in swiperList" :key="i">
            <img :src="item.imgSrc" />
            <div class="ItemTitle za_ItemTitle">{{ item.za_title }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hotArtIntroduce">
        <div class="section">
          <div class="hotArt">
            <div class="hotArt_text za_hotArt_text">རེབ་གོང་སྒྱུ་རྩལ།</div>
          </div>
          <div class="wow artContent animate__animated animate__bounceInRight">
            <img
              class="indexOne animate__animated animate__backInLeft za_indexOne"
              src="../assets/newImage/index/index_1.jpg"
              alt
            />
            <div class="contentTop za_contentTop">
              <div class="title za_title">
                <p>
                  རེབ་གོང་ནི་བོད་སྐད་“རེབ་གོང་”ཡིན་ཞིང་།དེའི་གོ་དོན་ནི་“ཕུགས་འདུན་མངོན་འགྱུར་བྱེད་པའི་གསེར་མདོག་གི་ལུང་ཁུག”ཅེས་པ་དེ་རེད།
                </p>
                <p>
                  མིང་དུ་གྲགས་པའི་རེབ་གོང་སྒྱུ་རྩལ་ནི་ས་འདི་ནས་མིང་དུ་གྲགས་པ་རེད།
                </p>
                <p>
                  རེབ་གོང་སྒྱུ་རྩལ་ནི་དུས་རབས་བཅུ་གསུམ་པར་བྱུང་བ་ཡིན་ཞིང་།དེའི་ནང་ཐང་ག་དང་།ལྡེབས་རིས།འཚེམ་དྲུབ་སོགས་སྒྱུ་རྩལ་གྱི་རྣམ་པ་ཚུད་ཡོད་ལ།ས་གནས་ཀྱི་སྲོལ་རྒྱུན་སྒྱུ་རྩལ་གྱི་གྲུབ་མཐའ་གལ་ཆེན་ཞིག་ཀྱང་ཡིན།
                </p>
                <p>
                  2006ལོར་རེབ་གོང་སྒྱུ་རྩལ་དེ་རྒྱལ་ཁབ་ཀྱི་མངོན་མིན་རིག་གནས་ཤུལ་བཞག་ཁག་དང་པོའི་མིང་གཞུང་ནང་བཅུག་པ་རེད།
                </p>
                <p>
                  2009ལོར་རེབ་གོང་སྒྱུ་རྩལ་མིའི་རིགས་ཀྱི་མངོན་མིན་རིག་གནས་ཤུལ་བཞག་གི་མཚོན་བྱེད་མིང་གཞུང་ནང་བཅུག་པ་རེད།
                </p>
                <p>
                  2018ལོར་རེབ་གོང་སྒྱུ་རྩལ་རྒྱལ་ཁབ་ཀྱི་སྲོལ་རྒྱུན་བཟོ་རྩལ་དར་རྒྱས་ཀྱི་དཀར་ཆག་ཁག་དང་པོར་བདམས་པ་རེད།
                </p>
                <br />
                <p>
                  སྤྱི་ཁྱབ་ཧྲུའུ་ཅི་ཞིས་ཅིན་ཕིང་གིས།<strong
                    >རྨ་ཆུའི་རིག་གནས་ཤུལ་བཞག་རྒྱུད་རིམ་ལྡན་པའི་སྒོ་ནས་སྲུང་སྐྱོང་བྱེད་པར་སྐུལ་འདེད་གཏོང་བ་དང་།མེས་པོས་ང་ཚོར་བཞག་པའི་རྩ་ཆེའི་ཤུལ་བཞག་སྲུང་སྐྱོང་ཡག་པོ་བྱ་དགོས།</strong
                  >
                </p>
              </div>
            </div>
          </div>
          <div
            class="indexTopleft wow artContent animate__animated animate__fadeInLeft"
          >
            <img src="../assets/indexImage/index_5.png" alt />
          </div>
        </div>
      </div>
      <div class="inheritor">
        <div id="all-box">
          <div
            v-for="(item, index) in List"
            :class="[
              'c-item-' + index,
              currsorIndex == index ? 'c-item-hover' : '',
            ]"
            @mouseover="mouseOver(index)"
            :key="index"
          >
            <div v-show="currsorIndex != index" class="title-box engLish_title-box">
              {{ item.zangName }}
            </div>
            <div class="currsor-content-box" v-if="index != 9 && index != 0">
              <div class="img">
                <img :src="url + item.picture[0].fileUrl" />
              </div>
              <div class="currsor-title-box">{{ item.zangName }}</div>
              <div class="inheritorNameList" v-if="item.inheritorLevelIdArrStr&&item.inheritorLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.inheritorLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                  <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                  <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                  <div v-if="items&&items==4">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་ཐུན་རིན་གྲོང་ཁྱེར་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                </div>
              </div>
              <div class="artistsLevelNameList" v-if="item.artistsLevelIdArrStr&&item.artistsLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.artistsLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">ཀྲུང་གོའི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་</div>
                  <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་ཆེན་མོ་</div>
                  <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                  <div v-if="items&&items==4">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་ཁྱེར་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item&&item.technologistLevel==1">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ་</div>
                <div v-if="item&&item.technologistLevel==2">མཚོ་སྔོན་ཞིང་ཆེན་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་དང་པོ་</div>
                <div v-if="item&&item.technologistLevel==3">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གཉིས་པ་</div>
                <div v-if="item&&item.technologistLevel==4">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གསུམ་པ་</div>
                <div v-if="item&&item.technologistLevel==5">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་དམངས་ཁྲོད་བཟོ་རྩལ་པ་</div>
                <div v-if="item&&item.technologistLevel==6">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་མིའི་བཟོ་རྩལ་པ་</div>
              </div>
            </div>
            <div class="currsor-content-box" v-if="index == 0">
              <div class="currsor-title-box">{{ item.zangName }}</div>
            </div>
            <div
              class="currsor-content-box"
              @click="goDetail"
              v-if="index == 9"
            >
              <div class="currsor-title-box">{{ item.zangName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="indexMiddle hidden-xs-only">
      <div class="section">
        <div class="tarbar">
          <tab-bar :tabNames="tabNamesList" @getIndex="getTarbar"></tab-bar>
        </div>
        <message-list :message="item"></message-list>
      </div>
    </div>
    <!-- 藏文手机端 -->
    <div class="mobile_indexTop hidden-sm-and-up">
      <div class="mobile_top">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(item, i) in mobileSwiperList" :key="i">
            <img :src="item.imgSrc" />
            <div class="ItemTitle za_ItemTitle">{{ item.za_title }}</div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="mobile_Introduce wow animate__animated animate__fadeInDown">
        <div class="section">
          <div class="hotArt">
            <div class="hotArt_title">
              <div class="hotArt_text za_hotArt_text">རེབ་གོང་སྒྱུ་རྩལ།</div>
            </div>
          </div>
          <div class="pic">
            <img src="../assets/newImage/index/index_1.jpg" alt="" />
          </div>
          <div class="contentTop">
            <p>
              རེབ་གོང་ནི་བོད་སྐད་“རེབ་གོང་”ཡིན་ཞིང་།དེའི་གོ་དོན་ནི་“ཕུགས་འདུན་མངོན་འགྱུར་བྱེད་པའི་གསེར་མདོག་གི་ལུང་ཁུག”ཅེས་པ་དེ་རེད།
            </p>
            <p>
              མིང་དུ་གྲགས་པའི་རེབ་གོང་སྒྱུ་རྩལ་ནི་ས་འདི་ནས་མིང་དུ་གྲགས་པ་རེད།
            </p>
            <p>
              རེབ་གོང་སྒྱུ་རྩལ་ནི་དུས་རབས་བཅུ་གསུམ་པར་བྱུང་བ་ཡིན་ཞིང་།དེའི་ནང་ཐང་ག་དང་།ལྡེབས་རིས།འཚེམ་དྲུབ་སོགས་སྒྱུ་རྩལ་གྱི་རྣམ་པ་ཚུད་ཡོད་ལ།ས་གནས་ཀྱི་སྲོལ་རྒྱུན་སྒྱུ་རྩལ་གྱི་གྲུབ་མཐའ་གལ་ཆེན་ཞིག་ཀྱང་ཡིན།
            </p>
            <p>
              2006ལོར་རེབ་གོང་སྒྱུ་རྩལ་དེ་རྒྱལ་ཁབ་ཀྱི་མངོན་མིན་རིག་གནས་ཤུལ་བཞག་ཁག་དང་པོའི་མིང་གཞུང་ནང་བཅུག་པ་རེད།
            </p>
            <p>
              2009ལོར་རེབ་གོང་སྒྱུ་རྩལ་མིའི་རིགས་ཀྱི་མངོན་མིན་རིག་གནས་ཤུལ་བཞག་གི་མཚོན་བྱེད་མིང་གཞུང་ནང་བཅུག་པ་རེད།
            </p>
            <p>
              2018ལོར་རེབ་གོང་སྒྱུ་རྩལ་རྒྱལ་ཁབ་ཀྱི་སྲོལ་རྒྱུན་བཟོ་རྩལ་དར་རྒྱས་ཀྱི་དཀར་ཆག་ཁག་དང་པོར་བདམས་པ་རེད།
            </p>
            <br />
            <p>
              སྤྱི་ཁྱབ་ཧྲུའུ་ཅི་ཞིས་ཅིན་ཕིང་གིས།<strong
                >རྨ་ཆུའི་རིག་གནས་ཤུལ་བཞག་རྒྱུད་རིམ་ལྡན་པའི་སྒོ་ནས་སྲུང་སྐྱོང་བྱེད་པར་སྐུལ་འདེད་གཏོང་བ་དང་།མེས་པོས་ང་ཚོར་བཞག་པའི་རྩ་ཆེའི་ཤུལ་བཞག་སྲུང་སྐྱོང་ཡག་པོ་བྱ་དགོས།</strong
              >
            </p>
          </div>
          <div class="indexList">
            <img src="../assets/newImage/mobile/index/index_1.png" alt />
          </div>
        </div>
        <img
          class="cloudLeft wow animate__animated animate__fadeInLeft"
          src="../assets/newImage/index/could_left.png"
          alt
        />
      </div>
      <div class="mobile_inheritor">
        <div class="hotArt">རྒྱུན་འཛིན་པ།</div>
        <div id="all-box">
          <div
            v-for="(item, index) in list"
            :class="[
              'c-item-' + index,
              currsorIndex == index ? 'c-item-hover' : '',
            ]"
            @mouseover="mobileMouseOver(index)"
            :key="index"
          >
            <div v-show="currsorIndex != index" class="title-box engLish_title-box">
              {{ item.zangName }}
            </div>
            <div class="currsor-content-box" v-if="index !== 3">
              <div class="img">
                <img :src="url + item.picture[0].fileUrl" />
              </div>
              <div class="currsor-title-box">{{ item.zangName }}</div>
              <div class="inheritorNameList" v-if="item.inheritorLevelIdArrStr&&item.inheritorLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.inheritorLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                  <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                  <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                  <div v-if="items&&items==4">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་ཐུན་རིན་གྲོང་ཁྱེར་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                </div>
              </div>
              <div class="artistsLevelNameList" v-if="item.artistsLevelIdArrStr&&item.artistsLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.artistsLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">ཀྲུང་གོའི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་</div>
                  <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་ཆེན་མོ་</div>
                  <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                  <div v-if="items&&items==4">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་ཁྱེར་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item&&item.technologistLevel==1">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ་</div>
                <div v-if="item&&item.technologistLevel==2">མཚོ་སྔོན་ཞིང་ཆེན་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་དང་པོ་</div>
                <div v-if="item&&item.technologistLevel==3">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གཉིས་པ་</div>
                <div v-if="item&&item.technologistLevel==4">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གསུམ་པ་</div>
                <div v-if="item&&item.technologistLevel==5">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་དམངས་ཁྲོད་བཟོ་རྩལ་པ་</div>
                <div v-if="item&&item.technologistLevel==6">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་མིའི་བཟོ་རྩལ་པ་</div>
              </div>
            </div>
            <div class="currsor-content-box" @click="goDetail" v-else>
              <div class="currsor-title-box">{{ item.zangName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_tarbar">
        <div class="section">
          <tab-bar :tabNames="tabNamesList" @getIndex="getTarbar"></tab-bar>
        </div>
      </div>
      <div class="section">
        <message-list :message="item"></message-list>
      </div>
    </div>
  </div>
  <div class="index" v-else>
    <div class="indexTop hidden-xs-only">
      <div class="indexTopSwiper">
        <el-carousel height="630px">
          <el-carousel-item v-for="(item, i) in swiperList" :key="i">
            <img :src="item.imgSrc" />
            <div class="ItemTitle">{{ item.title }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hotArtIntroduce">
        <div class="section">
          <div class="hotArt">
            <div class="hotArt_text">热贡艺术</div>
          </div>
          <div class="wow artContent animate__animated animate__bounceInRight">
            <img
              class="indexOne animate__animated animate__backInLeft"
              src="../assets/newImage/index/index_1.jpg"
              alt
            />
            <div class="contentTop">
              <div class="title">
                <p>同仁，藏语 “热贡”，意为“梦想成真的金色谷地”。</p>
                <p>远近闻名的热贡艺术，就因发祥于此地而得名。</p>
                <p>
                  热贡艺术产生于13世纪，包含唐卡、壁画、堆绣、雕塑等艺术形式，是重要地方传统艺术流派。
                </p>
                <p>2006年，热贡艺术入选第一批国家非物质文化遗产名录。</p>
                <p>2009年，热贡艺术入选人类非物质文化遗产代表作名录。</p>
                <p>2018年，热贡艺术入选第一批国家传统工艺振兴目录。</p>
                <br />
                <p>
                  习总书记曾指出：<strong
                    >要推进黄河文化遗产的系统保护，守好老祖宗留给我们的宝贵遗产。</strong
                  >
                </p>
              </div>
            </div>
          </div>
          <div
            class="indexTopleft wow artContent animate__animated animate__fadeInLeft"
          >
            <img src="../assets/indexImage/index_5.png" alt />
          </div>
        </div>
      </div>
      <div class="inheritor">
        <div id="all-box">
          <div
            v-for="(item, index) in List"
            :class="[
              'c-item-' + index,
              currsorIndex == index ? 'c-item-hover' : '',
            ]"
            @mouseover="mouseOver(index)"
            :key="index"
          >
            <div v-show="currsorIndex != index" class="title-box">
              {{ item.chineseName }}
            </div>
            <div class="currsor-content-box" v-if="index != 9 && index != 0">
              <div class="img">
                <img :src="url + item.picture[0].fileUrl" />
              </div>
              <div class="currsor-title-box">{{ item.chineseName }}</div>
              <div class="inheritorNameList" v-if="item.inheritorLevelIdArrStr&&item.inheritorLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.inheritorLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">国家级非遗项目热贡艺术代表性传承人</div>
                  <div v-if="items&&items==2">青海省非遗项目热贡艺术代表性传承人</div>
                  <div v-if="items&&items==3">青海省黄南州非遗项目热贡艺术代表性传承人</div>
                  <div v-if="items&&items==4">青海省黄南州同仁市非遗项目热贡艺术代表性传承人</div>
                </div>
              </div>
              <div class="artistsLevelNameList" v-if="item.artistsLevelIdArrStr&&item.artistsLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.artistsLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">中国工艺美术大师</div>
                  <div v-if="items&&items==2">青海省工艺美术大师</div>
                  <div v-if="items&&items==3">青海省黄南州工艺美术大师</div>
                  <div v-if="items&&items==4">青海省黄南州同仁市工艺美术大师</div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item&&item.technologistLevel==1">青海省民间工艺大师</div>
                <div v-if="item&&item.technologistLevel==2">青海省一级民间工艺师</div>
                <div v-if="item&&item.technologistLevel==3">青海省二级民间工艺师</div>
                <div v-if="item&&item.technologistLevel==4">青海省三级民间工艺师</div>
                <div v-if="item&&item.technologistLevel==5">青海省黄南州民间工艺师</div>
                <div v-if="item&&item.technologistLevel==6">青海省黄南州同仁市民间工艺师</div>
              </div>
            </div>
            <div class="currsor-content-box" v-if="index == 0">
              <div class="currsor-title-box">{{ item.chineseName }}</div>
            </div>
            <div
              class="currsor-content-box"
              @click="goDetail"
              v-if="index == 9"
            >
              <div class="currsor-title-box">{{ item.chineseName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="indexMiddle hidden-xs-only">
      <div class="section">
        <div class="tarbar">
          <tab-bar :tabNames="tabNamesList" @getIndex="getTarbar"></tab-bar>
        </div>
        <message-list :message="item"></message-list>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="mobile_indexTop hidden-sm-and-up">
      <div class="mobile_top">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(item, i) in mobileSwiperList" :key="i">
            <img :src="item.imgSrc" />
            <div class="ItemTitle">{{ item.title }}</div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="mobile_Introduce wow animate__animated animate__fadeInDown">
        <div class="section">
          <div class="hotArt">
            <div class="hotArt_title">
              <div class="hotArt_text">热贡艺术</div>
            </div>
          </div>
          <div class="pic">
            <img src="../assets/newImage/index/index_1.jpg" alt="" />
          </div>
          <div class="contentTop">
            <p>同仁，藏语 “热贡”，意为“梦想成真的金色谷地”。</p>
            <p>远近闻名的热贡艺术，就因发祥于此地而得名。</p>
            <p>
              热贡艺术产生于13世纪，包含唐卡、壁画、堆绣、雕塑等艺术形式，是重要地方传统艺术流派。
            </p>
            <p>2006年，热贡艺术入选第一批国家非物质文化遗产名录。</p>
            <p>2009年，热贡艺术入选人类非物质文化遗产代表作名录。</p>
            <p>2018年，热贡艺术入选第一批国家传统工艺振兴目录。</p>
            <br />
            <p>
              习总书记曾指出：<strong
                >要推进黄河文化遗产的系统保护，守好老祖宗留给我们的宝贵遗产。</strong
              >
            </p>
          </div>
          <div class="indexList">
            <img src="../assets/newImage/mobile/index/index_1.png" alt />
          </div>
        </div>
        <img
          class="cloudLeft wow animate__animated animate__fadeInLeft"
          src="../assets/newImage/index/could_left.png"
          alt
        />
      </div>
      <div class="mobile_inheritor">
        <div class="hotArt">传承人</div>
        <div id="all-box">
          <div
            v-for="(item, index) in list"
            :class="[
              'c-item-' + index,
              currsorIndex == index ? 'c-item-hover' : '',
            ]"
            @mouseover="mobileMouseOver(index)"
            :key="index"
          >
            <div v-show="currsorIndex != index" class="title-box">
              {{ item.chineseName }}
            </div>
            <div class="currsor-content-box" v-if="index !== 3">
              <div class="img">
                <img :src="url + item.picture[0].fileUrl" />
              </div>
              <div class="currsor-title-box">{{ item.chineseName }}</div>
              <div class="inheritorNameList" v-if="item.inheritorLevelIdArrStr&&item.inheritorLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.inheritorLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">国家级非遗项目热贡艺术代表性传承人</div>
                  <div v-if="items&&items==2">青海省非遗项目热贡艺术代表性传承人</div>
                  <div v-if="items&&items==3">青海省黄南州非遗项目热贡艺术代表性传承人</div>
                  <div v-if="items&&items==4">青海省黄南州同仁市非遗项目热贡艺术代表性传承人</div>
                </div>
              </div>
              <div class="artistsLevelNameList" v-if="item.artistsLevelIdArrStr&&item.artistsLevelIdArrStr.length>0">
                <div v-for="(items,index) in item.artistsLevelIdArrStr" :key="index">
                  <div v-if="items&&items==1">中国工艺美术大师</div>
                  <div v-if="items&&items==2">青海省工艺美术大师</div>
                  <div v-if="items&&items==3">青海省黄南州工艺美术大师</div>
                  <div v-if="items&&items==4">青海省黄南州同仁市工艺美术大师</div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item&&item.technologistLevel==1">青海省民间工艺大师</div>
                <div v-if="item&&item.technologistLevel==2">青海省一级民间工艺师</div>
                <div v-if="item&&item.technologistLevel==3">青海省二级民间工艺师</div>
                <div v-if="item&&item.technologistLevel==4">青海省三级民间工艺师</div>
                <div v-if="item&&item.technologistLevel==5">青海省黄南州民间工艺师</div>
                <div v-if="item&&item.technologistLevel==6">青海省黄南州同仁市民间工艺师</div>
              </div>
            </div>
            <div class="currsor-content-box" @click="goDetail" v-else>
              <div class="currsor-title-box">{{ item.chineseName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_tarbar">
        <div class="section">
          <tab-bar :tabNames="tabNamesList" @getIndex="getTarbar"></tab-bar>
        </div>
      </div>
      <div class="section">
        <message-list :message="item"></message-list>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { peoPle,visitCountGet } from "../api/management";
import TabBar from "../components/tabbar.vue";
import MessageList from "../components/messagelist.vue";
export default {
  components: {
    TabBar,
    MessageList,
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  data() {
    return {
      currsorIndex: 1,
      inheritorSwipers: [],
      mobileNum: "",
      url: process.env.VUE_APP_WEB_URL,
      language: this.$store.state.language,
      tabNamesList: [
        {
          name: "唐卡",
          englishName: "Thangka",
          zangName: "<div>ཐང་</div><div>ག</div>",
          // zaName: "ཐང་ག།",
          zaName: "ཐང་ག"
        },
        {
          name: "堆绣",
          // englishName: "Pile embroidery",
          englishName: "Embroidery",
          zangName: "<div>དྲས་</div><div>དྲུབ།</div>",
          // zaName: "ཐོ་ཡོར་ལ་འབུལ་རྒྱུ་འི།",
          zaName: "དྲས་དྲུབ།",
        },
        {
          name: "泥塑",
          // englishName: "Clay sculpture",
          englishName: "Sculpture",
          zangName: "<div>འཇིམ་</div><div>བཟོ།</div>",
          // zaName: "འཇིམ་བརྙན།",
          zaName: "འཇིམ་བཟོ།",
        },
        {
          name: "壁画",
          englishName: "Mural",
          zangName: "<div>ལྡེབས་</div><div>རིས།</div>",
          // zaName: "ལྡེབས་རིས།",
          zaName: "ལྡེབས་རིས།",
        },
        {
          name: "彩绘",
          englishName: "Paintings",
          zangName: "<div>ཚོན་</div><div>རིས།</div>",
          // zaName: "ཚོན་རིས།",
          zaName: "ཚོན་རིས།",
        },
        {
          name: "更多",
          englishName: "More",
          zangName: "<div>དེ་</div><div>ལས་</div><div>མང་</div><div>བ།</div>",
          // zaName: "དེ་བས་མང་བ།",
          zaName: "དེ་ལས་མང་བ།",
        },
      ],
      item: {},
      swiperList: [
        {
          imgSrc: require("../assets/newImage/swiper/1.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/swiper/2.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/swiper/3.png"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/swiper/4-1.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/swiper/swiper_5.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/swiper/swiper_6.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
      ],
      mobileSwiperList: [
        {
          imgSrc: require("../assets/newImage/mobile/index/1.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/mobile/index/2.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/mobile/index/3.png"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/mobile/index/4-1.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/mobile/index/swiper_5.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
        {
          imgSrc: require("../assets/newImage/mobile/index/swiper_6.jpg"),
          title: "热贡艺术",
          za_title: "རེབ་གོང་སྒྱུ་རྩལ།",
          eng_title: "Regong Art",
        },
      ],
      List: [],
      list: [],
      max_inheritor: 9 //显示的传承人个数 （最大10个）
    };
  },
  created() {
    this.getPle();
    this.getVisitCountGet()
    //防止页面刷新导致轮播效果消失
    this.inheritorSwipers = JSON.parse(localStorage.getItem("set"));
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  methods: {
    mouseOver(index) {
      //鼠标移入设置不同样式
      if (index != this.max_inheritor && index != 0) {
        this.currsorIndex = index;
      }
    },
    mobileMouseOver(index) {
      if (index != 3) {
        this.currsorIndex = index;
      }
    },
    getTarbar(item) {
      this.item = item;
    },
    async getPle() {
      const res = await peoPle(
        {
          current:1,
          pageSize:10,
          reception:true
        }
      );
      if (res.code == 1) {
        this.List = res.data.records.slice(0, this.max_inheritor-1);
        this.list = res.data.records.slice(0, 3);
        
        this.List.push({
          chineseName: "更多",
          zangName: "དེ་ལས་མང་བ།",
          englishName: "More",
        });
        this.List.unshift({
          chineseName: "传承人",
          zangName: "རྒྱུན་འཛིན་པ།",
          englishName: "Inheritor",
        });
        this.list.push({
          chineseName: "更多",
          zangName: "དེ་ལས་མང་བ།",
          englishName: "More",
        });
        localStorage.setItem("set", JSON.stringify(res.data));
      }
    },
    async getVisitCountGet() {
      const res = await visitCountGet()
      if(res.code==1) {
        this.$store.commit("changeStatistics", res.data);
      }
    },
    goDetail() {
      this.$router.push("/inherit");
    },
  },
};
</script>
<style lang="scss">
.index {
  background: url("../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 99%;
  background-size: 7%;
  .indexTop {
    .indexTopSwiper {
      width: 100%;
      height: 629px;
      position: relative;
      .el-carousel {
        .el-carousel__arrow {
          display: none;
        }
      }
      .el-carousel__item {
        img {
          position: absolute;
          width: 100%;
        }
        .ItemTitle {
          position: absolute;
          right: 7%;
          bottom: 50%;
          transform: translateY(50%);
          font-size: 90px;
          font-family: "fangzang";
          color: #fff;
        }
        .za_ItemTitle {
          font-size: 90px;
          right: 9%;
        }
        .eng_ItemTitle {
          font-size: 74px;
          font-family: "Times New Roman", Times, serif;
          right: 6%;
        }
      }
      .el-carousel__indicators {
        bottom: 20px;
        .el-carousel__indicator--horizontal {
          margin-left: 10px;
          height: 10px;
          width: 10px;
          padding: 0;
          .el-carousel__button {
            border-radius: 50%;
            height: 10px;
            width: 10px;
          }
        }
        .is-active {
          .el-carousel__button {
            background-color: #ed201a;
          }
        }
      }
    }
    .hotArtIntroduce {
      background: url("../assets/newImage/index/could_left.png") no-repeat top
        left;
      background-size: 7%;
      .section {
        margin-top: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .hotArt {
          margin: 30px 0 50px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: url("../assets/newImage/index/text_ring_red.png")
            no-repeat center;
          background-size: cover;
          width: 240px;
          height: 76px;
          .hotArt_text {
            padding-top: 10px;
            font-family: "fangzang";
            letter-spacing: 4px;
            font-size: 44px;
            margin: 0 4px;
            color: #981218;
          }
          .za_hotArt_text {
            line-height: 76px;
            font-family: "fangzang";
            letter-spacing: 4px;
            font-size: 32px;
            color: #981218;
            text-align: center;
          }
          .eng_hotArt_text {
            font-family: "Times New Roman", Times, serif;
          }
        }
        .artContent {
          display: flex;
          .indexOne {
            width: 490px;
            height: 500px;
            margin-right: 40px;
          }
          .za_indexOne {
            height: 600px;
            margin-top: 20px;
          }
          .eng_indexOne {
            height: 700px;
            margin-top: 20px;
          }
          .contentTop {
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 20px;
            .title {
              text-align: justify;
              p {
                line-height: 48px;
                letter-spacing: 2px;
                color: #595959;
              }
            }
            .za_title {
              p {
                font-size: 20px;
              }
            }
          }
          .za_contentTop {
            font-size: 18px;
          }
        }
        .indexTopleft {
          position: absolute;
          left: -29%;
          top: 0;
        }
      }
    }
    .inheritor {
      margin: 90px 0 0 0;
      height: 680px;
      background: url("../assets/newImage/index/inheritorBgc.png") no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      #all-box {
        margin-left: 10px;
        height: 100%;
        display: flex;
        display: -ms-flex;
        flex-direction: row;
        .c-item-0,
        .c-item-1,
        .c-item-2,
        .c-item-3,
        .c-item-4,
        .c-item-5,
        .c-item-6,
        .c-item-7,
        .c-item-8,
        .c-item-9 {
          height: 100%;
          width: 85px;
          border-right: 1px solid rgba(255, 255, 255, 0.2);
          transition: width 0.4s;
          transition-timing-function: ease;
          overflow: hidden;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 0.5s;
          transition-timing-function: ease;
        }
        .c-item-6 {
          cursor: pointer;
        }
        .c-item-hover {
          width: 400px;
          height: 100%;
          transition: all 0.5s;
          transition-timing-function: ease;
          .img-right-bg {
            opacity: 1;
            transition: all 0.5s linear;
          }
          .currsor-content-box {
            transition: all 0.5s linear;
            opacity: 1;
          }
        }
        .title-box {
          margin: 0 auto;
          width: 30px;
          font-size: 30px;
          color: rgba(255, 255, 255, 0.7);
        }
        .engLish_title-box {
          margin: 0 auto;
          width: 200px;
          font-size: 30px; 
          line-height: 24px;
          transform:rotate(90deg);
          -ms-transform:rotate(90deg); 	/* IE 9 */
          -moz-transform:rotate(90deg); 	/* Firefox */
          -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
          -o-transform:rotate(90deg); 	/* Opera */
          white-space: nowrap;
        }
        .currsor-content-box {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          position: absolute;
          z-index: 1;
          opacity: 0;
          .currsor-title-box {
            font-size: 30px;
            color: rgba(255, 255, 255, 0.7);
            margin: 6px 0;
          }
          .img {
            width: 270px;
            height: 360px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .inheritorNameList {
            color: rgba(255, 255, 255, 0.7);
            font-size:18px;
            margin-bottom: 6px;
            >div {
              display: flex;
              justify-content: center;
            }
          }
          .artistsLevelNameList {
            color: rgba(255, 255, 255, 0.7);
            font-size:18px;
            margin-bottom: 6px;
            >div {
              display: flex;
              justify-content: center;
            }
          }
          .folkLevelNameList {
            color: rgba(255, 255, 255, 0.7);
            font-size:18px;
            >div {
              display: flex;
              justify-content: center;
            }
          }
        }
      }
    }
  }
  .indexMiddle {
    padding: 40px 0;
    border-bottom: 1px solid #f4f5f6;
    .section {
      .middleList {
        display: flex;
        justify-content: space-between;
        padding-bottom: 60px;
        .title {
          display: flex;
          div {
            font-family: "fangzang";
            font-size: 16px;
            margin-left: 60px;
            writing-mode: tb-rl;
            letter-spacing: 2px;
          }
          .color {
            color: #bc9b67;
          }
        }
      }
      .hotArt {
        margin-top: 8px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 30px;
        img {
          height: 20px;
          vertical-align: bottom;
        }
        h1 {
          color: #374963;
          font-family: "fangzang";
          letter-spacing: 4px;
          margin: 0 4px;
        }
      }
      p {
        font-size: 15px;
        line-height: 25px;
      }
      .image {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        img {
          margin-bottom: 20px;
        }
        .fontSize {
          font-size: 15px;
          font-family: "fangzang";
        }
      }
    }
  }
  .indexBottom {
    padding: 40px 0;
    position: relative;
    .section {
      .hotArt {
        margin-top: 8px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 30px;
        img {
          height: 20px;
          vertical-align: bottom;
        }
        h1 {
          font-family: "fangzang";
          letter-spacing: 4px;
          margin: 0 4px;
          color: #374963;
        }
      }
      .imageList {
        height: 500px;
        display: flex;
        justify-content: space-between;
        .firstList {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .imageOne {
            display: flex;
            justify-content: space-between;
            .one {
              margin-right: 43px;
            }
          }
        }
      }
    }
    .indexBottomRight {
      position: absolute;
      right: 0;
      bottom: 20%;
    }
  }
}
@media (max-width: 768px) {
  .index {
    background: none;
    .mobile_indexTop {
      .mobile_top {
        height: 4rem;
        display: flex;
        .van-swipe {
          width: 100%;
          height: 4rem;
          .van-swipe-item {
            img {
              position: absolute;
              width: 100%;
              height: 100%;
            }
            .ItemTitle {
              font-family: "fangzang";
              position: absolute;
              right: 9%;
              bottom: 54%;
              transform: translateY(50%);
              font-size: 0.5rem !important;
              color: #fff;
            }
            .za_ItemTitle {
              font-size: 0.3rem !important;
              right: 10%;
              bottom: 50%;
            }
            .eng_ItemTitle {
              font-family: "Times New Roman", Times, serif;
              right: 6%;
            }
          }
          .van-swipe__indicator {
            background-color: #fff;
          }
          .van-swipe__indicator--active {
            background-color: #981318;
          }
        }
      }
      .mobile_Introduce {
        position: relative;
        .section {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .hotArt {
            margin: 0.6rem 0 0.4rem 0;
            display: flex;
            justify-content: center;
            .hotArt_title {
              display: flex;
              justify-content: center;
              align-items: center;
              background: url("../assets/newImage/index/text_ring_red.png")
                no-repeat center;
              background-size: contain;
              width: 2.8rem;
              height: 0.9rem;
              .hotArt_text {
                font-family: 'fangzang';
                padding-top: 0.15rem;
                letter-spacing: 4px;
                font-size: 0.5rem;
                margin: 0 4px;
                color: #981218;
              }
              .za_hotArt_text {
                font-size: 0.32rem;
              }
            }
          }
          .pic {
            img {
              width: 5rem;
              height: 6rem;
            }
          }
          .contentTop {
            .title {
              text-align: justify;
            }
            p {
              font-size: 0.28rem;
              line-height: 0.5rem;
            }
          }
          .indexList {
            margin: 0.3rem 0 0 0;
            img {
              width: 100%;
            }
          }
        }
        .cloudLeft {
          position: absolute;
          top: 0;
          left: 0;
          width: 1.1rem;
        }
      }
      .mobile_tarbar {
        .section {
          width: 100%;
        }
      }
      .mobile_inheritor {
        margin: 0.5rem 0 0.5rem 0;
        height: 5rem;
        background: url("../assets/newImage/index/inheritorBgc.png") no-repeat;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        .hotArt {
          height: 100%;
          cursor: pointer;
          writing-mode: tb-rl;
          font-family: "fangzang";
          font-size: 20px;
          color: rgba(255, 255, 255, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          .eng_hotArt_text {
            font-family: "Times New Roman", Times, serif;
          }
          .za_hotArt_text {
            font-size: 20px;
          }
        }
        #all-box {
          margin-left: 20px;
          height: 100%;
          display: flex;
          display: -ms-flex;
          flex-direction: row;
          .c-item-0 {
            border-left: 1px solid rgba(255, 255, 255, 0.2);
          }
          .c-item-0,
          .c-item-1,
          .c-item-2,
          .c-item-3,
          .c-item-4 {
            height: 100%;
            width: 1rem;
            border-right: 1px solid rgba(255, 255, 255, 0.2);
            transition: width 0.4s;
            transition-timing-function: ease;
            overflow: hidden;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.5s;
            transition-timing-function: ease;
            box-sizing:border-box;
          }
          .c-item-4 {
            cursor: pointer;
          }
          .c-item-hover {
            width: 2rem;
            height: 100%;
            transition: all 0.5s;
            transition-timing-function: ease;
            .img-right-bg {
              opacity: 1;
              transition: all 0.5s linear;
            }
            .currsor-content-box {
              transition: all 0.5s linear;
              opacity: 1;
            }
          }
          .title-box {
            margin: 0 auto;
            width: 20px;
            font-size: 20px; 
            color: rgba(255, 255, 255, 0.7);
          }
          .engLish_title-box {
            margin: 0 auto;
            width: 200px;
            font-size: 20px; 
            line-height: 24px;
            transform:rotate(90deg);
            -ms-transform:rotate(90deg); 	/* IE 9 */
            -moz-transform:rotate(90deg); 	/* Firefox */
            -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
            -o-transform:rotate(90deg); 	/* Opera */
            white-space: nowrap;
          }
          .currsor-content-box {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            position: absolute;
            z-index: 1;
            opacity: 0;
            .currsor-title-box {
              text-align: center;
              font-size: 18px;
              color: rgba(255, 255, 255, 0.7);
              margin: 4px 0;
            }
            .img {
              width: 1.2rem;
              height: 1.6rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .inheritorNameList {
              color: rgba(255, 255, 255, 0.7);
              font-size:.12rem;
              margin-bottom: 4px;
            }
            .artistsLevelNameList {
              color: rgba(255, 255, 255, 0.7);
              font-size:.12rem;
              margin-bottom: 4px;
            }
            .folkLevelNameList {
              color: rgba(255, 255, 255, 0.7);
              font-size:.12rem;
            }
          }
        }
      }
      .cloudLeft {
        position: absolute;
        top: 40%;
        left: 0;
        width: 1.1rem;
      }
    }
  }
}
</style>
